import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getEnvironment } from 'config/environment';

/**
 *  @todo: This initial state should be removed in the future.
 */
const initialState: Environment = getEnvironment();

const slice = createSlice({
    name: 'environment',
    initialState,
    reducers: {
        setConfig: (state, action: PayloadAction<Partial<Environment>>) => {
            return { ...state, ...action.payload };
        },
    },
});

export default slice;
